const os = require('os')

module.exports = {
  getIp(){
    const ifaces = os.networkInterfaces()
    let ip = ''
    for (const dev in ifaces) {
      ifaces[dev].forEach(function (details) {
        if (ip === '' && details.family === 'IPv4' && !details.internal) {
          ip = details.address
          return
        }
      })
    }
    return ip || '127.0.0.1'
  }
}



//////////////////
// WEBPACK FOOTER
// ./build/ip.js
// module id = 8vkk
// module chunks = 24